import _get from 'lodash/get';
import { call, put } from 'redux-saga/effects';

import { fetchPartnerByIdAPI } from 'modules/apis';

import * as userActions from '../actions';

/**
 * Fetch info for a given partner via a `partnerId`.
 *
 * @method fetchPartnerSaga
 * @type   {Generator}
 * @param  {Object}          action The redux action
 * @return {Object|Error}
 */
export function* fetchPartnerSaga(action) {
    try {
        // Extract the partnerId from the action.
        const { payload: partnerId } = action;
        // Make the call to fetch the partner with the given `partnerId`.
        const resp = yield call(fetchPartnerByIdAPI, partnerId);
        // Extract the partner from the valid response.
        const partner = _get(resp, 'data.company', {});
        // Dispatch the `fetchPartner` SUCCESS action.
        yield put(userActions.fetchPartner.success(partner));
        // Return the partner just in case.
        return partner;
    } catch (error) {
        // Otherwise catch the error and dispatch the `fetchPartner` ERROR action.
        yield put(userActions.fetchPartner.error(error));
        // Return the error.
        return error;
    }
}
